import { useSchedulingQuery as useQuery } from "./useSchedulingQuery";
import { listAllAvailability } from "../../components/api/Scheduling/availability";
import { onError } from "./onError";

export const availabilityKeys = {
  list: (organizationRef, filters) => ["scheduling-availability", organizationRef, filters],
};

export function useAvailabilityQuery({
  organizationRef,
  scheduleId,
  serviceCategoryId,
  startsAt,
  endsAt,
  active = true,
  onSuccess,
  enabled = true,
}) {
  const filters = { scheduleId, serviceCategoryId, startsAt, endsAt, active };
  return useQuery(
    availabilityKeys.list(organizationRef, filters),
    ({ signal, consistency }) => listAllAvailability({ organizationRef, ...filters, limit: 500, signal, consistency }),
    {
      enabled: !!organizationRef && enabled,
      keepPreviousData: false,
      staleTime: 30000, refetchOnWindowFocus: false, retry: false,
      onSuccess,
      onError,
    }
  );
}
